import SubMenu from "antd/es/menu/SubMenu";
import { all_routes } from "../../../feature-module/router/all_routes";
import { IoMdPeople } from "react-icons/io";
import { FaWhatsapp } from "react-icons/fa";
import { FaMessage } from "react-icons/fa6";
const route = all_routes;
export const SidebarData = [

  {
    // label: "CRM",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Dashboard",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
        link: route.agentDashboard,
      },
       {
              label: "Contacts",
              icon: "ti ti-user-up",
              submenu: true,
              showSubRoute: false,
              submenuItems: [
                {
                  label: "Contacts List",
                  link: route.agentContactList,
                  icon: <IoMdPeople />,
                },
                {
                  label: "FAQ",
                  link: route.agentFaq,
                  icon: <IoMdPeople />,
                },
              ],
            },
              {
              label: "Leads",
              icon: "ti ti-medal",
              submenu: false,
              showSubRoute: false,
              link: route.agentLeads,
              onClick: () => console.log("Leads Clicked"),
            },
              {
              label: "Calendar",
              icon: "ti ti-medal",
              submenu: false,
              showSubRoute: false,
              link: route.agentCalendar,
            },
      {
        label: "Calls",
        icon: "ti ti-medal",
        submenu: false,
        showSubRoute: false,
         link: route.agentCallAndRecording,
        // submenuItems: [
        //   {
        //     label: "Call Client",
        //     link: route.callAndRecording,
        //     icon: <IoMdPeople />,
        //   },
        // ],
      },

       {
        label: "Sync And Integration",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
         link: route.syncAndIntegration,
       
      },
      {
        label: "Settings",
        icon: "ti ti-code",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Profile Settings",
            link: route.agentProfile,
            icon: <IoMdPeople />,
          },
          {
            label: "Security",
            link: route.agentSecurity,
            icon: <IoMdPeople />,
          },
        ],
      },
      {
        label: "Import And Export",
        icon: "ti ti-layout-2",
        submenu: false,
        showSubRoute: false,
         link: route.agentImportAndExport,
      },
      {
        label: "Help & Support",
        icon: "ti ti-code",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "New Ticket",
            link: route.agentHelpAndSupport,
            icon: <IoMdPeople />,
          },
          {
            label: "Existing Ticket",
            link: route.myTicketsAgent,
            icon: <IoMdPeople />,
          },
        ],
      },
    ],
  },
];
